module.exports = "/_next/static/images/ME-df2a648bb56f58585818d9283beec7a8.png";